import { render, staticRenderFns } from "./ym-annals-target.vue?vue&type=template&id=1cd9599a&scoped=true&"
import script from "./ym-annals-target.vue?vue&type=script&lang=js&"
export * from "./ym-annals-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9599a",
  null
  
)

export default component.exports